import {
  createHubFilterStore,
  useGenericActiveProjectHubFilterCount,
  useGenericHasProjectHubFilters,
} from '@/shared/hooks/use-hub-filter-store';

export const useInsightsFilterStore = createHubFilterStore({
  name: 'insights-filter-storage',
  partialize: (state) => ({
    fromDate: state.fromDate,
    toDate: state.toDate,
    projectIds: state.projectIds,
    subprojectIds: state.subprojectIds,
  }),
});

export const useActiveInsightsFilterCount = () =>
  useGenericActiveProjectHubFilterCount(useInsightsFilterStore());
export const useHasInsightsFilters = () =>
  useGenericHasProjectHubFilters(useInsightsFilterStore());
